import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, empty } from 'rxjs';

@Injectable()
export class DataSharingService {

    public userLogged: BehaviorSubject<string> = new BehaviorSubject<string>(null);
}
